module.exports = __webpack_public_path__ + "static/media/trivia-time.f6fa2265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trivia-time.png
// module id = 86
// module chunks = 0